module.exports = __webpack_public_path__ + "img/section-3-content_2_img.530438ce.png";